// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"65":"f151b19f","303":"e42e56f2","571":"37507dda","623":"19f9aceb","968":"c63b05ad"}[chunkId] + ".js";
};